import { useTranslation } from "react-i18next";

import { RequirementBadgeProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const RequirementBadge = ({ isRequired }: RequirementBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={`module-requirement-badge body-xs-regular ${isRequired ? "module-requirement-badge-required" : ""}`}
    >
      {isRequired
        ? t("certification.module.required")
        : t("certification.module.notRequired")}
    </span>
  );
};

export default RequirementBadge;
